// extracted by mini-css-extract-plugin
export default {"root":"PlasmicUserManagement_root__Optn-","rootselected":"PlasmicUserManagement_rootselected__3W350","text":"PlasmicUserManagement_text__OYsAR"};